document.addEventListener('DOMContentLoaded', function () {
  var cartDrawer = document.getElementById('cart-drawer');
  var overlay = document.querySelector('.cart-drawer__overlay');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
  }
  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;

  document.body.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) {
      e.preventDefault();
      openCartDrawer();
      refreshCartDrawer();
    }
    if (e.target.closest('[data-cart-close]') || e.target.closest('.cart-drawer__overlay')) {
      closeCartDrawer();
    }
    if (e.target.closest('[data-search-toggle]')) {
      e.preventDefault();
      var sd = document.querySelector('.search-drawer');
      if (sd) {
        sd.classList.toggle('is-open');
        if (sd.classList.contains('is-open')) {
          var input = sd.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      }
    }
    if (e.target.closest('[data-search-close]')) {
      var sd2 = document.querySelector('.search-drawer');
      if (sd2) sd2.classList.remove('is-open');
    }
    if (e.target.closest('[data-mobile-nav-toggle]')) {
      var nav = document.querySelector('.site-nav');
      if (nav) {
        var isOpen = nav.classList.toggle('is-open-mobile');
        var btn = e.target.closest('[data-mobile-nav-toggle]');
        if (btn) btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    }
    if (e.target.closest('[data-filter-toggle]')) {
      var fs = document.querySelector('.filter-sidebar');
      if (fs) fs.classList.toggle('is-open');
    }
    var accTrigger = e.target.closest('.product-accordion__trigger');
    if (accTrigger) {
      var item = accTrigger.closest('.product-accordion__item');
      item.classList.toggle('is-open');
    }
    var qtyBtn = e.target.closest('[data-quantity-change]');
    if (qtyBtn) {
      var wrapper = qtyBtn.closest('.quantity-selector');
      var input = wrapper.querySelector('input[type="number"]');
      var dir = qtyBtn.getAttribute('data-quantity-change');
      var val = parseInt(input.value || '1', 10);
      val = dir === 'increase' ? val + 1 : Math.max(1, val - 1);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      var key = removeBtn.getAttribute('data-cart-remove');
      updateCartLine(key, 0);
    }
  });

  // Add to cart via AJAX for any form with data-product-form
  document.body.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var formData = new FormData(form);
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        return refreshCartDrawer();
      })
      .then(function () {
        openCartDrawer();
      })
      .catch(function (err) { console.error(err); })
      .finally(function () {
        if (submitBtn) submitBtn.removeAttribute('disabled');
      });
  });

  // Quantity change in cart drawer/page updates cart
  document.body.addEventListener('change', function (e) {
    var qtyInput = e.target.closest('[data-cart-quantity]');
    if (qtyInput) {
      var key = qtyInput.getAttribute('data-cart-quantity');
      updateCartLine(key, qtyInput.value);
    }
  });

  function updateCartLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () { refreshCartDrawer(); if (document.body.classList.contains('template-cart')) { location.reload(); } })
      .catch(function (err) { console.error(err); });
  }

  function refreshCartDrawer() {
    if (!cartDrawer) return Promise.resolve();
    return fetch('/?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newContent = doc.querySelector('#cart-drawer-content');
        var target = cartDrawer.querySelector('#cart-drawer-content');
        if (newContent && target) target.innerHTML = newContent.innerHTML;
      })
      .catch(function (err) { console.error(err); });
  }

  // Variant/option selection swatches
  document.querySelectorAll('.swatch-list input').forEach(function (input) {
    input.addEventListener('change', function () {
      var group = input.closest('.swatch-list');
      group.querySelectorAll('label').forEach(function (l) { l.classList.remove('is-selected'); });
      var label = group.querySelector('label[for="' + input.id + '"]');
      if (label) label.classList.add('is-selected');
    });
  });

});

// Sorting: swap only the sort_by part of the address, so filters and search words are kept
document.addEventListener('change', function (e) {
  var select = e.target.closest ? e.target.closest('[data-sort-select]') : null;
  if (!select) return;
  var url = new URL(window.location.href);
  url.searchParams.set('sort_by', select.value);
  url.searchParams.delete('page');
  window.location.href = url.toString();
});

// ---------- Product photos: thumbnails, hover zoom, and the larger-photo viewer ----------
(function () {
  var box = null, boxImg = null, boxCount = null, prevBtn = null, nextBtn = null;
  var index = 0, media = [], lastFocus = null, sourceFrame = null, touchX = null;

  function readMedia() {
    var el = document.getElementById('ProductMediaData');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (err) { return []; }
  }

  function setActiveThumb(i) {
    document.querySelectorAll('.product-gallery__thumbs img').forEach(function (t) {
      t.classList.toggle('is-active', parseInt(t.getAttribute('data-index'), 10) === i);
    });
  }

  function build() {
    if (box) return;
    box = document.createElement('div');
    box.className = 'lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product photos');
    box.innerHTML =
      '<button type="button" class="lightbox__btn lightbox__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="lightbox__btn lightbox__prev" aria-label="Previous photo">&#8249;</button>' +
      '<img class="lightbox__img" alt="">' +
      '<button type="button" class="lightbox__btn lightbox__next" aria-label="Next photo">&#8250;</button>' +
      '<div class="lightbox__count"></div>';
    document.body.appendChild(box);
    boxImg = box.querySelector('.lightbox__img');
    boxCount = box.querySelector('.lightbox__count');
    prevBtn = box.querySelector('.lightbox__prev');
    nextBtn = box.querySelector('.lightbox__next');

    box.addEventListener('click', function (e) {
      if (e.target.closest('.lightbox__close')) return close();
      if (e.target.closest('.lightbox__prev')) return show(index - 1);
      if (e.target.closest('.lightbox__next')) return show(index + 1);
      if (e.target === box) close();            // click on the empty backdrop
    });
    box.addEventListener('touchstart', function (e) { touchX = e.changedTouches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX; touchX = null;
      if (Math.abs(dx) > 50) show(index + (dx < 0 ? 1 : -1));
    });
  }

  function show(i) {
    var n = media.length;
    if (!n) return;
    index = (i + n) % n;
    boxImg.src = media[index].src;
    boxImg.alt = media[index].alt || '';
    boxCount.textContent = n > 1 ? (index + 1) + ' / ' + n : '';
    prevBtn.style.display = nextBtn.style.display = n > 1 ? '' : 'none';
  }

  function open(frame, start) {
    media = readMedia();
    if (!media.length) return;
    build();
    sourceFrame = frame;
    box.classList.toggle('lightbox--dark', frame.getAttribute('data-lightbox-style') === 'dark');
    lastFocus = document.activeElement;
    show(start);
    box.classList.add('is-open');
    document.body.classList.add('lightbox-open');
    box.querySelector('.lightbox__close').focus();
  }

  function close() {
    if (!box || !box.classList.contains('is-open')) return;
    box.classList.remove('is-open');
    document.body.classList.remove('lightbox-open');
    // keep the page's main photo in step with the one that was being viewed
    if (sourceFrame && media[index]) {
      var img = sourceFrame.querySelector('img');
      if (img && img.tagName === 'IMG') { img.src = media[index].main; }
      sourceFrame.setAttribute('data-index', String(index));
      setActiveThumb(index);
      document.dispatchEvent(new CustomEvent('product:photo-change', { detail: { index: index, mediaId: media[index].id } }));
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest ? e.target.closest('.product-gallery__thumbs img') : null;
    if (thumb) {
      var frame = document.querySelector('[data-zoom-frame]');
      var main = frame && frame.querySelector('img');
      if (main) {
        main.src = thumb.getAttribute('data-full-src') || thumb.src;
        main.alt = thumb.alt || main.alt;
        frame.setAttribute('data-index', thumb.getAttribute('data-index') || '0');
        setActiveThumb(parseInt(thumb.getAttribute('data-index') || '0', 10));
        document.dispatchEvent(new CustomEvent('product:photo-change', { detail: { index: parseInt(thumb.getAttribute('data-index') || '0', 10), mediaId: thumb.getAttribute('data-media-id') } }));
      }
      return;
    }
    var f = e.target.closest ? e.target.closest('[data-zoom-frame][data-lightbox]') : null;
    if (f) open(f, parseInt(f.getAttribute('data-index') || '0', 10));
  });

  document.addEventListener('keydown', function (e) {
    if (box && box.classList.contains('is-open')) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(index - 1);
      else if (e.key === 'ArrowRight') show(index + 1);
      return;
    }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-zoom-frame][data-lightbox]')) {
      e.preventDefault();
      open(e.target, parseInt(e.target.getAttribute('data-index') || '0', 10));
    }
  });

  // a real mouse is in use (this is what turns the hover zoom on; touch screens never do)
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType === 'mouse') document.documentElement.classList.add('has-mouse');
  }, { passive: true });

  // hover zoom follows the mouse
  document.addEventListener('mousemove', function (e) {
    var f = e.target.closest ? e.target.closest('[data-zoom-frame]') : null;
    if (!f) return;
    var r = f.getBoundingClientRect();
    if (!r.width || !r.height) return;
    f.style.setProperty('--zoom-x', ((e.clientX - r.left) / r.width * 100) + '%');
    f.style.setProperty('--zoom-y', ((e.clientY - r.top) / r.height * 100) + '%');
  });
})();

// Troubleshooting: add ?stock=debug to a collection page to see what Shopify reports for each product
document.addEventListener('DOMContentLoaded', function () {
  if (location.search.indexOf('stock=debug') === -1) return;
  document.querySelectorAll('.product-card[data-stock-debug]').forEach(function (card) {
    var note = document.createElement('div');
    note.style.cssText = 'font:10px/1.3 monospace;color:#B3261E;margin-top:4px;word-break:break-word;';
    note.textContent = 'shows: ' + card.getAttribute('data-stock-state') + ' | ' + card.getAttribute('data-stock-debug');
    card.appendChild(note);
  });
});
